import PropTypes from 'prop-types';
import styles from './switch.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import InteractiveElement from '../../../atoms/interactive-element';

const className = augmentClassName(styles);

const Switch = ({
  checked,
  onChange,
  label,
  styleClass
}) => {
  return (
    <label {...className('container', 'root', 'mx-6', styleClass)}>
      <div {...className('switch', 'screener-switch')}
        // TIAA Analytics Tracking
        data-analytics-linkname={label.replace(/ /g, '_')}
        data-analytics-section="component"
        data-analytics-componenttype="Toggle"
        // END TIAA Analytics Tracking
      >
        <InteractiveElement
          as="input"
          type="checkbox"
          onChange={onChange}
          id={label}
          label={label}
          checked={checked}/>
        <span {...className('slider', 'round')}></span>
      </div>
      <div {...className('label')}>{label}</div>
    </label>
  );
};

Switch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  styleClass: PropTypes.string
};

export default Switch;
